import { decode } from "jsonwebtoken";
import { Tokens } from "../Interfaces/Interfaces";

export function TokenValidator() {
  let store = JSON.parse(localStorage.getItem("persist:root") || "{}");
  const tokens: Tokens = JSON.parse(store.tokens);

  if (Object.entries(tokens).length !== 0) {
    const decoded: any = decode(tokens.access_token);
    if (Date.now() >= decoded.exp * 1000) {
      sessionStorage.removeItem("auth");
      localStorage.clear();

      window.location.pathname = "/";
    } else {
      // persist userType
      decoded.user_type &&
        sessionStorage.setItem("userType", JSON.stringify(decoded.user_type));
      return tokens;
    }
  }
}
